import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
// import { SERASA_CONSUMIDOR } from '@ecs/heimdall/constants';
// import { environment, redirect } from '@env/environment';
// import { UserAuthIamService } from '@/services/user-auth-iam/user-auth-iam.service';
// import { UserService } from '@/services/user-auth/user.service';
import { HeaderSerasaService } from './header-serasa.service';
import { Product } from './header-product';

const originBaseUrl = 'https://www.serasa.com.br';

@Component({
    selector: 'dp-header-serasa',
    styleUrls: ['./header-serasa.component.scss'],
    template: `
        <div #heimdallWrapper class="heimdall-wrapper"></div>
    `,
    encapsulation: ViewEncapsulation.None
})
export class HeaderSerasaComponent implements OnInit, OnDestroy, AfterViewInit {
    private product: Product;
    public userData = {
        name: '',
        picture: ''
    };

    @ViewChild('heimdallWrapper') public heimdallWrapper: ElementRef;

    // constructor(private headerService: HeaderSerasaService, private userService: UserService, private iamService: UserAuthIamService) {
        constructor() {
        // this.product = this.headerService.getProduct(SERASA_CONSUMIDOR);

        // this.iamService.currentUserData.subscribe(data => {
        //     if (data) {
        //         const { fullName, picture } = data;
        //         const name = fullName.split(' ')[0];

        //         this.userData = { name, picture };
        //         this.buildHeader();
        //     }
        // });
    }

    public ngOnInit() {
        window.addEventListener('resize', this.handleResize);
    }

    public ngOnDestroy() {
        window.removeEventListener('resize', this.handleResize);
    }

    public ngAfterViewInit() {
        this.buildHeader();
    }

    private buildHeader = (): void => {
        this.heimdallWrapper.nativeElement.innerHTML = '';

        // this.headerService.build(
        //     {
        //         environment: environment.name,
        //         product: this.product.key,
        //         loggedIn: true,
        //         profile: {
        //             picture: this.userData.picture || './assets/images/navbar-avatar.png',
        //             name: this.userData.name
        //         },
        //         brand: {
        //             path: redirect.homePath,
        //             logo: {
        //                 default: this.product.logo,
        //                 negative: this.product.logoWhite
        //             }
        //         },
        //         login: {
        //             path: `/`
        //         },
        //         logout: {
        //             callback: () => {
        //                 this.userService.logout().subscribe();
        //             }
        //         },
        //         signUp: {
        //             path: `/`,
        //             text: 'Cadastrar'
        //         },
        //         config: {
        //             color: this.product.color,
        //             background: this.product.color
        //         }
        //     },
        //     this.heimdallWrapper.nativeElement
        // );

        this.addPaddingToBody(this.heimdallHeaderElem);
        this.replaceMenuLinks(this.heimdallHeaderElem);
    }

    private get heimdallHeaderElem(): HTMLScriptElement {
        return this.heimdallWrapper && this.heimdallWrapper.nativeElement.querySelector('header');
    }

    private handleResize = (): void => {
        this.addPaddingToBody(this.heimdallHeaderElem);
    }

    private addPaddingToBody = (elem: HTMLScriptElement): void => {
        // Add padding to body according to heimdall header height
        const bodyElem = document.querySelector('body');

        if (elem) {
            bodyElem.style.paddingTop = elem.offsetHeight.toString() + 'px';
        }
    }

    private replaceMenuLinks = (elem: HTMLScriptElement): void => {
        // Replace menu link host to match external domain

        //@ts-ignore
        const anchors = elem.querySelectorAll('a[href^=' / ']');

        Array.prototype.forEach.call(anchors, anchor => {
            const href = anchor.getAttribute('href');
            // Replace links without absolute paths
            if (!href.match(/http?s|www/gi) && href !== '/') {
                anchor.setAttribute('href', `${originBaseUrl}${href}`);
            }
        });
    }
}
